import { defineGraphqlClientOptions } from 'nuxt-graphql-middleware/client-options'

export default defineGraphqlClientOptions<{
  language: string
  hash: string
  env: 'client' | 'server'
  auHash?: string
}>({
  buildClientContext() {
    const language = useCurrentLanguage()
    const config = useRuntimeConfig()
    const route = useRoute()
    const auHash = route.query.auHash

    return {
      language: language.value,
      hash: `${config.public.buildHash}`,
      env: import.meta.server ? 'server' : 'client',
      auHash: typeof auHash === 'string' ? auHash : undefined,
    }
  },
})
